module.exports = __webpack_public_path__ + "img/logo-kbi-white.19f38a36.svg";